import v4Provider from './I18nProvider';

export default v4Provider;
